import { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, Paper, Alert, FormControlLabel, Checkbox, Grid, Button } from '@mui/material';
import ApiClient from "../../utilities/apiClient"
import AppConfig from '../../AppConfig';
import { useSelector } from 'react-redux';
import MyLodder from "../../components/lodder";

const PdfPreview = ({ pdfUrl, loading, responseData }) => {
    const sanitizedUrl = pdfUrl ? `${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0` : '';

    const [isAcknowledged, setIsAcknowledged] = useState(false);
    const [eSignRes, seteSignRes] = useState({})
    const [pdfError, setPdfError] = useState(null)
    const [showlodder, setShowLodder] = useState(false);
    const apiToken = useSelector(state => state.auth.apiToken);

    useEffect(() => {
        (async () => {
            try {
                setShowLodder(true);
                setPdfError(null)
                const apiClient = new ApiClient(apiToken);

                apiClient
                    .fetchData(
                        AppConfig.api.Request.eSign,
                        "POST",
                        responseData
                    )
                    .then((response) => {
                        if (!response) {
                            console.error("Error: Response is missing.");
                            return;
                        }

                        console.log("esign response", response.data)

                        if (response?.data?.status === 200) {
                            console.log("urrll", response?.data?.url, response)
                            seteSignRes(response?.data?.url)
                            setShowLodder(false);
                        } else if (response?.data?.status === 500) {
                            setShowLodder(false);
                            const errorMessage =
                                response.statusText ||
                                (response.details && response.details["Error Description"]);
                            console.error("Error 500: ", errorMessage);
                            setPdfError(true)
                        } else {
                            setShowLodder(false);
                            console.warn("Unexpected response status:", response.status);
                            setPdfError(true)
                        }

                    })
                    .catch((error) => {
                        setShowLodder(false);
                        console.error("Error during API request:", error);
                            setPdfError(true)

                    })
            } catch (error) {
                setShowLodder(false);
                console.error("Error during API request:", error);
                            setPdfError(true)

            }
        })()
    }, [])


    return (
        <>
            <Box>
                <Typography sx={{ color: "#131E2E", fontSize: { xs: "16px", sm: "18px", md: "20px" }, fontWeight: "bold", mb: 3 }}>
                    e-Sign your Nomination Form
                </Typography>

                {pdfError && (<Alert severity="error" sx={{ mt: 2 }}>
                    Error in esign step. Please try again later.
                </Alert>)}

                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '300px',
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : pdfUrl ? (
                    <Paper
                        elevation={3}
                        sx={{
                            overflow: 'hidden',
                            borderRadius: 2,
                            height: {
                                xs: '60vh',
                                sm: '70vh',
                                md: '600px'
                            },
                        }}
                    >
                        <Box
                            component="object"
                            data={sanitizedUrl}
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            sx={{
                                border: 'none',
                            }}
                        >
                            <Typography sx={{ p: 2 }}>
                                PDF preview is not supported on your device.{" "}
                                <a href={sanitizedUrl} target="_blank" rel="noopener noreferrer">Click here to download</a>.
                            </Typography>
                        </Box>
                    </Paper>

                ) : null}

                {pdfUrl && (<>

                    <Grid sx={{ mt: 2 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isAcknowledged}
                                    onChange={(e) => setIsAcknowledged(e.target.checked)}
                                    sx={{ color: "#333" }}
                                />
                            }

                            label={
                                <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                    By proceeding, I acknowledge that I have fully read, completely understood and agree to the Terms & Conditions, Disclaimers and Privacy Policy of TradeBoss.
                                </Typography>
                            }
                        />
                    </Grid>

                    <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                        <Button
                            disabled={!isAcknowledged}
                            sx={{ color: !isAcknowledged && "#999 !important", fontWeight: 600 }}
                            onClick={() => {
                                if (eSignRes) {
                                    window.open(eSignRes, "_self");
                                }
                            }}
                        >
                            Proceed to Next
                        </Button>
                    </Box>
                </>)}
            </Box>
            <MyLodder canShow={showlodder} />
            </>
       
        
    );
};

export default PdfPreview;
